import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';

type ActionTypeButton = {
  text: string;
  value: string;
}

type actionTypeData = {
  buttons: ActionTypeButton[];
  data?: boolean;
}

@Component({
    selector: 'action-type',
    templateUrl: './action-type.component.html',
    styleUrls: ['./action-type.component.scss'],
    imports: [MatButtonToggleGroup, MatButtonToggle]
})
export class ActionTypeComponent implements OnInit {
  @Input() buttonsData: undefined[] | ActionTypeButton[] = [];
  @Input() selectedValue: string;
  @Input() disabled: boolean;
  @Output() change = new EventEmitter()

  constructor() { }

  ngOnInit() {
    if (this.buttonsData.length) {
      this.selectedValue = this.selectedValue || this.buttonsData[0].value
    }
  }
  
  toggleChange(value: string) {
    if (this.selectedValue !== value) {
      this.selectedValue = value
      this.change.emit(value)
    }
  }

}
